import styles from './ccf-interaction-workspace.module.scss';
import { useSelector } from 'react-redux';
import { DigitalChannelType, MediaType } from '@nice-ccf/core-sdk';
import { CcfInteractionSpaceHeaderTab } from './ccf-interaction-space-header-tab/ccf-interaction-space-header-tab';
import CcfInteractionBody from './ccf-interaction-body/ccf-digital-contact-body';
import {
  activeContactSelector,
  getActiveInteractionType,
  getApplicationDirection,
} from '@nice-ccf/ui-components';
import { createStyles, makeStyles } from '@mui/styles';
import { Direction, Theme } from '@mui/material';
import CcfDispositionInteraction from '../ccf-disposition/ccf-disposition';
import CcfLiveDispositionInteraction from '../ccf-disposition/ccf-live-disposition';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginRight: theme.spacing(2) + 'px !important',
    },
  })
);

const dialPadIcons = new Map([
  [DigitalChannelType.CHAT.toString(), <h1>Web Chat</h1>],
  [DigitalChannelType.INSTAGRAM.toString(), <h1>INSTAGRAM</h1>],
  [DigitalChannelType.SMS.toString(), <h1>SMS</h1>],
  [DigitalChannelType.FACEBOOK.toString(), <h1>FACEBOOK</h1>],
  [DigitalChannelType.LINKEDIN.toString(), <h1>LINKEDIN</h1>],
  [DigitalChannelType.EMAIL.toString(), <h1>EMAIL</h1>],
  [DigitalChannelType.CHATWITHBOTRANSCRIPT.toString(), <h1>Web Chat</h1>],
  [DigitalChannelType.VIDEOCALL.toString(), <h1>CRM</h1>],
]);

/* eslint-disable-next-line */
export interface CcfInteractionWorkspaceProps {}

/**
 * Component displays InteractionWorkspace for selected contact
 * @returns InteractionWorkspace for selected contact
 * ```
 * @example
 * <CcfInteractionWorkspace/>
 * ```
 */
function setChannelForAddedContacts(type: any) {
  switch (type) {
    case 'sms':
      return 'sms';
    case 'Email':
      return 'Email';
    case 'Instagram':
      return 'Instagram';
    case 'Facebook':
      return 'Facebook';
    case 'Chat':
      return 'Chat';
    case 'X':
      return 'X';
    case 'ChatWithBotTranscript':
      return 'ChatWithBotTranscript';
    case 'VideoCall':
      return 'VideoCall';
    case 'reimbursementClaim':
      return 'reimbursementClaim';
    default:
      return '';
  }
}

/**
 * Component displays InteractionWorkspace for selected contact
 * @returns InteractionWorkspace for selected contact
 * ```
 * @example
 * <CcfInteractionWorkspace/>
 * ```
 */
export function CcfInteractionWorkspace(props: CcfInteractionWorkspaceProps) {
  const classes = useStyles();
  // const actInteraction = useSelector(activeInteraction);
  const appDirection: Direction = useSelector(getApplicationDirection);
  // const activeTab = actInteraction.activeTab;
  const activeInteractionType = useSelector(getActiveInteractionType);
  // const activeTab = actInteraction && actInteraction.activeTab;
  const selectedCallContact = useSelector(activeContactSelector);
  const interactionType = setChannelForAddedContacts(activeInteractionType);
  // selectedCallContact && selectedCallContact.channel
  //   ? selectedCallContact.channel
  //   : setChannelForAddedContacts(activeInteractionType);
  const activecontact = useSelector(activeContactSelector);
  const isCopilotSourceLiveLLM = activecontact?.copilotSource === 'Live LLM';
  const selectedCallContactWithAddedChannel = Object.assign(
    {},
    selectedCallContact
  );
  selectedCallContactWithAddedChannel.channel = setChannelForAddedContacts(
    activeInteractionType
  );
  selectedCallContactWithAddedChannel.id =
    selectedCallContactWithAddedChannel.id;

  if (
    interactionType === DigitalChannelType.FACEBOOK ||
    interactionType === DigitalChannelType.TWITTER ||
    interactionType === DigitalChannelType.INSTAGRAM ||
    interactionType === DigitalChannelType.EMAIL ||
    interactionType === DigitalChannelType.CHAT ||
    interactionType === DigitalChannelType.SMS ||
    interactionType === DigitalChannelType.CHATWITHBOTRANSCRIPT ||
    interactionType === 'VideoCall' ||
    interactionType === 'reimbursementClaim'
  ) {
    selectedCallContact &&
      dialPadIcons.set(
        interactionType.toString(),
        <CcfInteractionBody
          selectedCallContact={selectedCallContactWithAddedChannel}
          // data={{[interactionType]:interactionMockData(selectedCallContact.id)[interactionType as keyof typeof interactionMockData]}}
        />
      );
  }

  return activeInteractionType ? (
    <div className={styles.dispotionContainer}>
      <div
        className={
          appDirection === 'rtl'
            ? styles.containerForRtl
            : styles.containerForLtr
        }
        id="agent_interactionWorkspace"
      >
        <CcfInteractionSpaceHeaderTab
          showDragIcon
          RightIcon={false}
          headerTextClassess="customerName marginLeft12"
        />
        {activeInteractionType && dialPadIcons.get(activeInteractionType)}
      </div>

      <div className={styles.flexFooter}>
        {isCopilotSourceLiveLLM ? (
          <CcfLiveDispositionInteraction />
        ) : (
          ((selectedCallContact?.media === MediaType.VOICE &&
            !('interaction' in selectedCallContact)) ||
            (selectedCallContact?.media === MediaType.DIGITAL &&
              interactionType !== DigitalChannelType.VIDEOCALL &&
              interactionType !== 'reimbursementClaim')) && (
            <CcfDispositionInteraction />
          )
        )}
      </div>
    </div>
  ) : null;
}

export default CcfInteractionWorkspace;
